var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    fill: "none",
    viewBox: "0 0 320 320"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#book_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "m160 280 1.334-2.001c9.262-13.893 13.893-20.839 20.011-25.868a53.4 53.4 0 0 1 18.367-9.83C207.29 240 215.639 240 232.336 240h18.331c14.934 0 22.402 0 28.106-2.906a26.67 26.67 0 0 0 11.654-11.654c2.906-5.705 2.906-13.172 2.906-28.107V82.667c0-14.935 0-22.402-2.906-28.107a26.67 26.67 0 0 0-11.654-11.654C273.069 40 265.601 40 250.667 40h-5.334c-29.869 0-44.804 0-56.212 5.813a53.33 53.33 0 0 0-23.308 23.308C160 80.529 160 95.464 160 125.333M160 280V125.333M160 280l-1.334-2.001c-9.262-13.893-13.893-20.839-20.011-25.868a53.4 53.4 0 0 0-18.367-9.83C112.71 240 104.361 240 87.664 240h-18.33c-14.935 0-22.403 0-28.107-2.906a26.67 26.67 0 0 1-11.654-11.654c-2.906-5.705-2.906-13.172-2.906-28.107V82.667c0-14.935 0-22.402 2.906-28.107a26.67 26.67 0 0 1 11.654-11.654C46.93 40 54.399 40 69.333 40h5.334c29.869 0 44.804 0 56.212 5.813a53.33 53.33 0 0 1 23.308 23.308C160 80.529 160 95.464 160 125.333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "book_svg__a",
    x1: 50.325,
    x2: 567.746,
    y1: 46.626,
    y2: 266.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgBook;